<template>
    <el-container style="height: 100%;">
        <el-aside>
            <admin-side-bar></admin-side-bar>
        </el-aside>
        <el-container>
            <el-header style="text-align: right; font-size: 12px; border-bottom: black solid 1px; display: flex; align-items: center; justify-content: flex-end">
                <el-dropdown>
                    <i class="el-icon-setting" style="margin-right: 15px"></i>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>View</el-dropdown-item>
                        <el-dropdown-item>Add</el-dropdown-item>
                        <el-dropdown-item>Delete</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <span>Tom</span>
            </el-header>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</el-container>
</template>
<script>
import axios from 'axios'
import AdminSideBar from './AdminSideBar'
export default {
    components: {
        AdminSideBar
    },
    data() {
        return {
            email: '',
            password: ''
        }
    },
    methods: {
        handleLogin() {
            this.loading = true;
            axios.post('/auth', {

                    username: this.email,
                    password: this.password

                }, {
                    headers: {
                        'Bearer': 'JWT eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZGVudGl0eSI6IjEiLCJpYXQiOjE1NTkyNTY4ODYsIm5iZiI6MTU1OTI1Njg4NiwiZXhwIjoxNTU5MjU3MTg2fQ.4HoRA8OCUYQneHEpkIcgPLtuC6KKG9Hh8MacEWJBDu8'
                    }
                })
                .then(response => {
                    localStorage.token = response.data.access_token
                    this.$router.replace(this.$route.query.redirect || '/')
                })
                .catch(error => {
                    console.log(error);
                    this.errorMessage = error.response.data.message
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>